module.exports = __webpack_public_path__ + "5ad9ff43206e19ddae0615022fc61cb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/charity-navigator.jpg
// module id = 1618
// module chunks = 0